// 配置 开发环境、生产环境baseurl地址
const CONFIG = {
  // 开发环境配置
  development: {
    baseUrl: "https://bestway.fujiekeji.com.cn",
    ssoBaseUrl: "https://bestway.fujiekeji.com.cn",
    // ssoBaseUrl: "http://192.168.2.230:10010",
    client_id:'dingpsaduwrhj3ah7skr',
    isDev: true,
  },
  // 测试环境配置
  test: {
    baseUrl: "http://192.168.2.232:8098",
    ssoBaseUrl: "http://192.168.2.232:8098",
    client_id:'dingtbolourunzx75ent',
    isDev: true,
  },
  testUAT: {
    baseUrl: "http://192.168.2.235:8098",
    ssoBaseUrl: "http://192.168.2.235:8098",
    client_id:'dingtbolourunzx75ent',
    isDev: true,
  },
  // 生产环境配置
  production: {
    baseUrl: "https://bestway.fujiekeji.com.cn",
    ssoBaseUrl: "https://bestway.fujiekeji.com.cn",
    client_id:'dingpsaduwrhj3ah7skr',
    isDev: false,
  },
};

module.exports = CONFIG[process.env.VUE_APP_ENV || process.env.NODE_ENV];
